<template>
  <v-dialog v-model="show">
    <v-card class="mt-2">
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">INVOICE PDF UPLOAD</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="save()">保存</v-btn>
        <tdoc-file-upload
          :disabled="selected.length !== 1"
          @addAttachment="addAttachment"
          style="margin: 0px 15px"
          type="INVOICE"
          :id="this.selected[0] && selected[0].id"
          title="UPLOAD"
        ></tdoc-file-upload>
        <v-btn @click="gotoList()" small>{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>

      <v-data-table
        :headers="headers"
        :items="bl.invoices"
        :rows-per-page-items="[10]"
        class="elevation-0"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>
              <v-checkbox
                hide-details
                primary
                v-model="props.selected"
              ></v-checkbox>
            </td>

            <td v-for="(header, index) in headers" :key="index">
              {{ props.item[header.value] }}
            </td>
          </tr>
          <tr>
            <template>
              <td></td>
              <td colspan="5">
                <ul class="doc">
                  <li
                    v-for="file in props.item.attachments"
                    :key="file.fileOssId"
                  >
                    <div @click="$downloadTdocFile(file)">{{ file.name }}</div>
                    <span
                      @click="removeAttachment(props.item, file)"
                      class="material-icons del-btn"
                    >
                      delete_outline
                    </span>
                  </li>
                </ul>
              </td>
            </template>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      bl: {
        invoices: [],
      },
      currentInvoice: {},
      query: {
        siNos: [],
        files: [],
      },
      show: false,
      valid: false,
      headers: [
        {
          text: "INV No",
          value: "invNo",
          sortable: false,
        },
        {
          text: "SEC Ref  No",
          value: "secRefNo",
          sortable: false,
        },
        {
          text: "BOOK No",
          value: "bkNo",
          sortable: false,
        },
        {
          text: "E/D No",
          value: "edNo",
          sortable: false,
        },
        {
          text: "S/I No",
          value: "siNo",
          sortable: false,
        },
      ],
      selected: [],
    };
  },
  methods: {
    popup(id) {
      this.show = true;
      this.load(id);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      this.$http
        .put(`tdoc/bls/${this.bl.id}`, {
          ...this.bl,
        })
        .then(() => {
          this.gotoList();
          this.$message("", "保存しました。");
        })
        .catch((err) => {
          if (this.$te(`tdoc.${err.response.data}`)) {
            this.$message("", this.$t(`tdoc.${err.response.data}`));
          } else {
            this.$message("", this.$t("app.system.error"));
          }
        });
    },
    load(id) {
      this.$http.get(`/tdoc/bls/${id}`).then((res) => {
        this.bl = res.data;
      });
    },
    validInvAttachmentDump(attachment) {
      if (
        this.selected[0].attachments &&
        this.selected[0].attachments
          .map((a) => a.name)
          .indexOf(attachment.name) !== -1
      ) {
        return true;
      }
      return false;
    },
    addAttachment(attachment) {
      if (this.validInvAttachmentDump(attachment)) {
        this.$message("", "InvoiceのPDFファイル名が重複しています。");
        return;
      }
      if (!this.selected[0].attachments) {
        this.selected[0].attachments = [];
      }
      this.selected[0].attachments.push(attachment);
      this.refreshInvAttachmentDate();
    },
    removeAttachment(invoice, attachment) {
      const index = invoice.attachments
        .map((i) => i.fileOssId)
        .indexOf(attachment.fileOssId);
      if (index > -1) {
        invoice.attachments.splice(index, 1);
        this.$forceUpdate();
        this.$message("", "invoiceファイル削除しました。");
        this.refreshInvAttachmentDate();
      }
    },
    refreshInvAttachmentDate() {
      this.bl.invAttachmentUpdateDate = this.$today();
    },
    gotoList() {
      this.show = false;
      this.$emit("refresh");
    },
  },
};
</script>

<style scoped>
.doc {
  margin: 0px;
  padding: 0px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 12px;
  padding: 5px 0px;
}

.doc li {
  padding: 0px 15px 0px 25px;
  list-style: none;
  background: transparent url(../../assets/img/pdf.svg) no-repeat;
  background-size: contain;
  display: flex;
  align-items: center;
  font-weight: bold;
  cursor: pointer;
}

.del-btn {
  margin-left: 10px;
  color: #666;
  cursor: pointer;
  z-index: 999;
}
</style>
